import { cls } from "@wss/cls";
import React, { HTMLAttributes } from "react";

type RecaptchaDisclaimerProps = HTMLAttributes<HTMLSpanElement> & {
  anchorProps?: HTMLAttributes<HTMLAnchorElement>;
  inline?: boolean;
};

export function RecaptchaDisclaimer({
  anchorProps,
  className,
  inline = false,
  ...rest
}: RecaptchaDisclaimerProps) {
  return (
    <span
      className={cls(
        "block mt-2.5 text-2xs leading-tight text-gray-600",
        className,
      )}
      {...rest}
    >
      This form is protected by reCAPTCHA and the Google
      {inline ? " " : <br />}
      <a
        href="https://policies.google.com/privacy"
        rel="noopener noreferrer"
        target="_blank"
        className={cls("underline text-green-500", anchorProps?.className)}
        {...anchorProps}
      >
        Privacy Policy
        <span className="sr-only">Opens in new tab</span>
      </a>{" "}
      and{" "}
      <a
        href="https://policies.google.com/terms"
        rel="noopener noreferrer"
        target="_blank"
        className={cls("underline text-green-500", anchorProps?.className)}
        {...anchorProps}
      >
        Terms of Service
        <span className="sr-only">Opens in new tab</span>
      </a>{" "}
      apply.
    </span>
  );
}
